import $http from "../utils/http"; // 导入http中创建的axios实例

const aiAssistant = {
  // 获取聊天记录列表
  getChatHistories(params) {
    return $http.get(`${global.API_URL}/sme/api/ai/sessions`, {params: params});
  },
  // 删除聊天记录
  deleteChatHistory(id, params) {
    return $http.delete(`${global.API_URL}/sme/api/ai/sessions/` + id, {params: params});
  },
  // 获取聊天记录详情
  getChatDetails(id, params) {
    return $http.get(`${global.API_URL}/sme/api/ai/sessions/` + id + '/messages',{params: params});
  },
  // 停止聊天输出
  stopStream(id, params) {
    return $http.post(`${global.API_URL}/sme/api/ai/` + id + '/stop', params);
  }
}

export default aiAssistant;



// WEBPACK FOOTER //
// ./src/api/aiAssistant.js